module.exports = __webpack_public_path__ + "static/img/forget.eb0c88f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/forget.svg
// module id = lKq7
// module chunks = 3